

export default function NoteIcon() {
    return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Note">
        <ellipse id="Ellipse 8" cx="3.36045" cy="18.407" rx="2.99009" ry="2.09306" fill="#795CEF"/>
        <ellipse id="Ellipse 9" cx="13.8358" cy="16.5059" rx="2.99009" ry="2.09306" fill="#795CEF"/>
        <path id="Vector 28" d="M5.83032 18.407V7.11938" stroke="#795CEF"/>
        <path id="Vector 29" d="M16.3257 16.5056V5.21802" stroke="#795CEF"/>
        <path id="Rectangle 9" d="M5.17969 5.33752C5.17969 4.91258 5.44825 4.53404 5.84934 4.39366L15.6437 0.965623C16.2939 0.738061 16.9741 1.22063 16.9741 1.90948V5.90886C16.9741 6.33381 16.7055 6.71234 16.3044 6.85272L6.51004 10.2808C5.85986 10.5083 5.17969 10.0257 5.17969 9.3369V5.33752Z" fill="#795CEF"/>
        </g>
    </svg> )
}
